import { GET_TRASH, GET_TRASH_ERROR, GET_TRASH_SUCCESS } from "../actions/types";

const initialState = {
  ideas: {
    contradictionSolving: [],
    eureka: [],
    replacement: [],
    multiplication: [],
    subtraction: [],
    detailsMatrix: [],
  },
  components: [],
  attributes: [],
  projects: [],
  isLoadingTrash: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_TRASH:
      return { ...state, isLoadingTrash: true };
    case GET_TRASH_SUCCESS:
      return {
        ...initialState,
        ...action.payload,
      };
    case GET_TRASH_ERROR:
      console.error(action.payload);
    default:
      return state;
  }
}
